<h2 mat-dialog-title>Fotogallery</h2>

<mat-dialog-content>
  <p class="galleria-modifica__aiuto">
    Trascina le foto per cambiare l'ordine. La didascalia è facoltativa: quando c'è, compare sotto la foto e diventa
    il testo alternativo per chi non la vede.
  </p>

  @if (voci().length) {
    <ul class="galleria-modifica" (dragend)="fineTrascinamento()">
      @for (voce of voci(); track voce.chiave; let i = $index) {
        <li
          class="galleria-modifica__voce"
          [class.galleria-modifica__voce--sopra]="sopra() === i"
          draggable="true"
          (dragstart)="iniziaTrascinamento(i, $event)"
          (dragover)="sopraA(i, $event)"
          (drop)="rilascia(i, $event)"
        >
          <mat-icon class="galleria-modifica__presa" aria-hidden="true">drag_indicator</mat-icon>

          <img class="galleria-modifica__anteprima" [src]="voce.anteprima" [alt]="voce.didascalia || 'Foto ' + (i + 1)" />

          <div class="galleria-modifica__campi">
            <mat-form-field class="galleria-modifica__didascalia">
              <mat-label>Didascalia della foto {{ i + 1 }}</mat-label>
              <input
                matInput
                [value]="voce.didascalia"
                (input)="scriviDidascalia(i, $any($event.target).value)"
                autocomplete="off"
              />
            </mat-form-field>
            <span class="galleria-modifica__misura">
              {{ voce.larghezza }}&times;{{ voce.altezza }} px
              @if (!voce.url) {
                · da caricare
              }
            </span>
          </div>

          <div class="galleria-modifica__azioni">
            <button
              type="button"
              mat-icon-button
              aria-label="Sposta su"
              matTooltip="Sposta su"
              [disabled]="i === 0"
              (click)="muovi(i, -1)"
            >
              <mat-icon>arrow_upward</mat-icon>
            </button>
            <button
              type="button"
              mat-icon-button
              aria-label="Sposta giù"
              matTooltip="Sposta giù"
              [disabled]="i === voci().length - 1"
              (click)="muovi(i, 1)"
            >
              <mat-icon>arrow_downward</mat-icon>
            </button>
            <button type="button" mat-icon-button aria-label="Togli la foto" matTooltip="Togli" (click)="togli(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </li>
      }
    </ul>
  } @else {
    <p class="galleria-modifica__vuoto">Nessuna foto. Aggiungine almeno una.</p>
  }

  <input type="file" accept="image/*" multiple hidden #scelta (change)="scegli($event)" />
  <button
    type="button"
    mat-stroked-button
    class="galleria-modifica__aggiungi"
    [disabled]="postiLiberi === 0 || caricamentoInCorso()"
    (click)="scelta.click()"
  >
    <mat-icon>add_photo_alternate</mat-icon>
    Aggiungi foto
  </button>
  <span class="galleria-modifica__conteggio">{{ voci().length }} / {{ massimo }}</span>

  @if (caricamentoInCorso()) {
    <mat-progress-bar mode="indeterminate" aria-label="Caricamento delle foto" />
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" mat-button [disabled]="caricamentoInCorso()" (click)="annulla()">Annulla</button>
  <button type="button" mat-flat-button color="primary" [disabled]="caricamentoInCorso()" (click)="conferma()">
    {{ caricamentoInCorso() ? 'Carico…' : voci().length ? 'Inserisci la gallery' : 'Togli la gallery' }}
  </button>
</mat-dialog-actions>
